import { Injectable } from '@angular/core';
import { User } from '@shared/entities/user';
import { ApiService } from '@shared/services';
import { Observable, catchError, map, of } from 'rxjs';

const LOG_PREFIX = '[Api][UserForm] ';

@Injectable({
  providedIn: 'root'
})
export class UserFormService extends ApiService<User> {
  constructor() {
    const masterUrl = '/users';
    const detailUrl = '/users';
    super(User, masterUrl, detailUrl, undefined, 'user-form');
  }

  findUser(id: string): Observable<User | null> {
    this.logger.debug(LOG_PREFIX + `findUser with id: ${id}`);
    return this.findOne(id).pipe(
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'findUser error', error);
        return of(null);
      })
    );
  }

  saveUser(userData: User): Observable<User | null> {
    this.logger.debug(LOG_PREFIX + 'saveUser', userData);
    return this.save(userData).pipe(
      map((response) => {
        this.logger.debug(LOG_PREFIX + 'saveUser success', response);
        return response || userData;
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'saveUser error', error);
        return of(error);
      })
    );
  }

  editUser(userData: User, userId: string): Observable<User | null> {
    this.logger.debug(LOG_PREFIX + `editUser with id: ${userId}`, userData);
    return this.save(userData, userId).pipe(
      map((response) => {
        this.logger.debug(LOG_PREFIX + 'editUser success', response);
        return response || userData;
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'editUser error', error);
        return of(error);
      })
    );
  }

  findByFilter(id: string): Observable<User | null> {
    this.logger.debug(LOG_PREFIX + `findByFilter user with id: ${id}`);

    this.setUrlParameter('id', id);

    return this.paginate(User, 1, 1).pipe(
      map((paginate) => {
        if (paginate && paginate.data && paginate.data.length > 0) {
          return paginate.data[0];
        }
        return null;
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'findByFilter error', error);
        return of(null);
      })
    );
  }

  deleteUser(id: string): Observable<boolean | null> {
    this.logger.debug(LOG_PREFIX + `deleteUser with id: ${id}`);
    return this.remove(id).pipe(
      map(() => {
        this.logger.debug(LOG_PREFIX + 'deleteUser success');
        return true;
      }),
      catchError((error) => {
        this.logger.error(LOG_PREFIX + 'deleteUser error', error);
        return of(error);
      })
    );
  }
}
